<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="协议名称">
					<c-input name="agreement_name" maxlength="50"></c-input>
				</m-search-item>
			</m-search>
			<c-table ref="list" height="grow" :paging="true">

<!--				<c-table-column-->
<!--					label="协议代码"-->
<!--					name="agreement_code"-->
<!--					width="100"-->
<!--				>-->
<!--				</c-table-column>-->

                <c-table-column
					label="协议名称"
					name="agreement_name"
					width="200"
				>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

                <c-table-column
                        label="更新人"
                        name="update_user_realname"
                        width="110"
                >
                </c-table-column>

                <c-table-column
                        label="更新时间"
                        name="update_date"
                        width="140"
                ></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="110"
				>
					<template #default="{data}">
					    <c-table-button v-if="auth('b_legal_agreement_view')" icon="tf-edit" @click="viewLegalAgreement(data)">查看</c-table-button>
                        <c-table-button v-if="auth('b_legal_agreement_edit')" icon="tf-edit" @click="editLegalAgreement(data)">编辑</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--创建/编辑单位信息弹窗-->
			<legal-agreement-edit ref="legalAgreementEdit" @resolve="$refs.list.update()"></legal-agreement-edit>
            <!--用户协议详情弹窗-->
            <legal-agreement-detail ref="legalAgreementDetail"></legal-agreement-detail>
		</module>
	</page>
</template>

<script>
	import legalAgreementEdit from "@/pages/basic/legal_agreement_edit.vue";
    import legalAgreementDetail from "@/pages/basic/legal_agreement_detail.vue";


    export default {
		components: {
            legalAgreementEdit,
            legalAgreementDetail
		},
		
		props: {
			type: String
		},

		data() {
			return {

			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/legal_agreement/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
			},

			/******新建/编辑单位*******/
            editLegalAgreement(data) {
				this.$refs.legalAgreementEdit.open(data);
			},
            viewLegalAgreement(data) {
                this.$refs.legalAgreementDetail.id = data.id;
                this.$refs.legalAgreementDetail.open();

            },
		}
	}
</script>

<style lang="stylus" scoped>
</style>